// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box, useTheme } from '@mui/system';
import { useAppSelector } from 'Hooks';
import { Typography } from '@mui/material';
import stylesDef from './styles';
import DeliverableListItem from './DeliverableListItem';

interface DeliverableSelectProps {
  onAddOnsClick: (selectedList: { item: IDeliverable, checked: boolean }[]) => void;
}

const DeliverableSelect = ({ onAddOnsClick }: DeliverableSelectProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  const getSubtype = (bundleType: string, subtype: string) => {
    const subtypeMapping: Record<string, string> = {
      Topography: bundleType === 'utilities' ? 'Topography & Segmentation' : 'Topography',
    };
    return subtypeMapping[subtype] || subtype;
  };

  const { additionalDeliverables, selectedBundle } = useAppSelector(
    (state) => state.bundle,
  );
  const { bundleId } = selectedBundle || {};

  const deliverablesBoolean = additionalDeliverables?.some((d) => d.subtype === 'Deliverables');
  const topographyDeliverableBoolean = selectedBundle.type !== 'utilities' ? additionalDeliverables?.some((d) => d.subtype === 'Topography' && d.type === 'deliverable') : additionalDeliverables?.some((d) => d.subtype === 'Topography & Segmentation' && d.type === 'deliverable');

  let additionalDeliverablesFiltered = additionalDeliverables;

  // remove CAD Drawing (.dxf) from additionalDeliverables list for standard a-la-carte bundle(bundleId === 5)
  if (bundleId === 5) {
    additionalDeliverablesFiltered = additionalDeliverables.filter((del) => (del.deliverableId !== 10));
  }

  return (
    <Box sx={styles.addons}>
      <Typography sx={styles.addonsHeading} variant="h3">
        Additional Deliverables
      </Typography>
      <Typography>Please select any additional deliverables you’d like to receive for your project.</Typography>
      {bundleId === 4 && (
        <Typography sx={styles.noDeliverableMessage}>
          Please select the 2D + TOPO bundle to add the disabled deliverables at checkout
        </Typography>
      )}
      {deliverablesBoolean && (
        <div>
          <Typography sx={styles.addonsHeading} variant="h4">
            Deliverables
          </Typography>
          {additionalDeliverablesFiltered.map((item) =>
            ((item.type === 'deliverable' && item.subtype === 'Deliverables') ? (
              <DeliverableListItem
                key={item._id}
                item={item}
                onAddOnsClick={onAddOnsClick}
              />
            ) : ''))}
        </div>
      )}

      {topographyDeliverableBoolean && (
        <Box sx={(bundleId === 0) && styles.unavailableDeliverables}>
          <Typography sx={styles.addonsHeading} variant="h4">
            {getSubtype(selectedBundle.type, 'Topography')}
          </Typography>
          {(bundleId === 0) && (
            <Typography sx={styles.noDeliverableMessage}>
              Please select the 2D + TOPO bundle to add Topography features at checkout
            </Typography>
          )}
          {additionalDeliverablesFiltered.map((item) =>
            ((item.type === 'deliverable' && item.subtype === getSubtype(selectedBundle.type, 'Topography')) ? (
              <DeliverableListItem
                key={item._id}
                item={item}
                onAddOnsClick={onAddOnsClick}
              />
            ) : ''))}
        </Box>
      )}
    </Box>
  );
};

export default DeliverableSelect;
